import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { LogLevel, LogType } from "../models/core/log.models";
import { AppConfigService } from "./app-config.service";

@Injectable({
  providedIn: 'root',
})
export class LogService {
  constructor(private http: HttpClient,
    private appConfigService: AppConfigService) { }

  debug(msg: string, optionalParams: any = null) {
    this.writeToLog(msg, LogLevel.Debug, optionalParams);
  }

  info(msg: string, optionalParams: any = null) {
    this.writeToLog(msg, LogLevel.Info, optionalParams);
  }

  warn(msg: string, optionalParams: any = null) {
    this.writeToLog(msg, LogLevel.Warn, optionalParams);
  }

  error(msg: string, optionalParams: any = null) {
    this.writeToLog(msg, LogLevel.Error, optionalParams);
  }

  redactEmail(email: string) {
    var parts = email.split('@');
    
    var start = parts[0][0];    
    if (parts[0].length > 1) {
      start += "*".repeat(parts[0].length - 1);
    }

    return start + '@' + parts[1];
  }

  private writeToLog(msg: string, level: LogLevel, params: any = null) {
    if (this.shouldLog(level)) {

      if (environment.logType == LogType.Console) {
        let value: string = new Date() + " - ";
        value += "Type: " + LogLevel[level];
        value += " - Message: " + msg;

        if (params != null) {
          value += " - Extra Info: " + this.formatParams(params);
        }

        console.log(value);
      } else {
        var value = "Message: " + msg;

        if (params != null) {
          value += " - Extra Info: " + this.formatParams(params);
        }

        this.serverLog(level, value)      
      }
    }
  }

  private shouldLog(level: LogLevel): boolean {
    if (level >= environment.logLevel) {
      return true;
    }
    return false;
  }

  private formatParams(params: any): string {
    if (params != null) {
      return JSON.stringify(params);
    }
    return '';
  }

  private serverLog(level: LogLevel, msg: string){    
    var url = this.appConfigService.getLoadedConfig().communityApiUrl + "/api/ClientLog/";
    switch (level) {
      case LogLevel.Debug:
        url += "debug";
        break;
      case LogLevel.Info:
        url += "information";
        break;
      case LogLevel.Warn:
        url += "warning";
        break;
      case LogLevel.Error:
        url += "error";
        break;
      default:
    }

    let headers = new HttpHeaders();
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    this.http.post(url, { message: msg }, { headers: headers })
      .subscribe(_ => { });
  }
}
